import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { HTTPService, HelperService, DataService, DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';
import { DatePipe } from '@angular/common';
import { find, findIndex, lowerCase, trim } from 'lodash';
import { tireTypeSuggestions } from 'app/constants';

interface IBrand {
    brandName: string;
    brandID: string;
    id: string;
    _id: string;
};

interface IItemType {
    name: string;
    partTerminologyID: string;
};

interface IProductLine {
    subCategoryId: string;
    subCategoryName: string;
    name: string,
    categoryId: string;
    _id: string
}

interface ICoveredProduct {
    brand: IBrand;
    productLine: IProductLine;
    productLineSuggestions: Array<any>;
    productLineResults: Array<any>;
    brandWarrantySuggestion: Array<any>;
    selectedProductLines: Array<any>;
    isLoadingSubBrands: boolean;
    isLoadingBrands: boolean;
    brandError: boolean;
    subBrandError: boolean;
};

interface IWarranty {
    title: string;
    type: IItemType;
    coveredProducts: ICoveredProduct[];
    titleError: boolean;
    itemTypeError: boolean;
};


@Component({
    selector: 'app-warranty-add-dialog',
    templateUrl: './warranty-add-dialog.component.html',
    styleUrls: ['./warranty-add-dialog.component.scss']
})
export class WarrantyAddDialogComponent implements OnInit {
    isEditMode: boolean = false;
    warranty = {
        title: '',
        type: {
            name: '',
            partTerminologyID: ''
        },
        coveredProducts: [],
        titleError: false,
        itemTypeError: false
    };
    warrantySuggestions: any[] = [];
    warrantySuggestionsList: any[] = [];
    warrantyProductLineSuggestions: any[] = [];
    warrantyBrandsSuggestion: any[] = [];
    searchBrandQuery = '';
    isLoading: boolean = false;
    isSubmitting: boolean = false;
    warrantyId: string;
    isWarrantyPartType: boolean = false;
    defaultTireTypeSuggestion = tireTypeSuggestions;

    constructor(
        private dynamicDialogRef: DynamicDialogRef,
        private dialogService: DialogService,
        private dConfig: DynamicDialogConfig,
        private httpService: HTTPService,
        private helperService: HelperService,
        private dataService: DataService,
        private datePipe: DatePipe,
        private dateService: DateService,
    ) { }

    ngOnInit(): void {
        const { _id, type } = this.dConfig?.data;
        this.isWarrantyPartType = type === 'part' ? true : false;
        if (_id) {
            this.warrantyId = _id;
            this.isEditMode = true;
        }
        if (this.isWarrantyPartType) {
            this.getData();
        } else {
            this.getTireTypes();
        }
        // else {
        //     this.addAnotherCoverdProductLine();
        // }
    }

    setData(data: any) {
        const itemType: IItemType = find(this.warrantySuggestions, { partTerminologyID: data.partType.id });
        this.warranty.title = data.title;
        this.warranty.type = itemType;
        this.warranty.coveredProducts = [];
        this.isLoading = false;
        if (this.isWarrantyPartType) {
            this.setBrandsData(data);
        }
    }

    setBrandsData(data: any) {
        data.coveredBrands?.forEach((coveredItem: any) => {
            const productLineObj: ICoveredProduct = this.getCoverdProductLineObject();
            productLineObj.brand = find(this.warrantyBrandsSuggestion, { brandID: coveredItem.brand.id });
            productLineObj.selectedProductLines = coveredItem?.productLines?.map((selectedItem: any) => {
                return {
                    subCategoryId: selectedItem.id,
                    subCategoryName: selectedItem.name
                };
            }) || [];
            this.warranty.coveredProducts.push(productLineObj);
        });
        if (!this.warranty.coveredProducts.length) {
            this.warranty.coveredProducts.push(this.getCoverdProductLineObject());
        } else {
            this.setSubBrands();
        }

    }

    setSubBrands() {
        let promisesArray: any[] = [];
        this.warranty.coveredProducts.forEach((coveredItem: ICoveredProduct) => {
            if (coveredItem?.brand?.brandID) {
                const conf = {
                    offset: 0,
                    limit: 27,
                    searchQuery: '',
                    itemType: this.getItemType(),
                    codeType: 'brand',
                    categoryId: coveredItem.brand.brandID
                };
                promisesArray.push(this.getSubBrandsByBrandIds(conf));
            }
        });
        if (promisesArray?.length) {
            Promise.allSettled(promisesArray).then(
                (results: any[]) => {
                    if (results?.length) {
                        const { category, subCategories } = results[0].value;
                        const index = findIndex(this.warranty.coveredProducts, (item: ICoveredProduct) => {
                            return item.brand.brandID === category?.categoryId;

                        });
                        subCategories?.forEach((subBrand: any) => {
                            if (index > -1) {
                                const selectedIndex = findIndex(this.warranty.coveredProducts[index].selectedProductLines, { subCategoryId: subBrand.subCategoryId });
                                if (selectedIndex < 0) {
                                    this.warranty.coveredProducts[index].productLineSuggestions.push({
                                        ...subBrand,
                                        categoryId: category?.categoryId,
                                        name: subBrand.subCategoryName
                                    });
                                }

                                this.warranty.coveredProducts[index].productLineResults.push({
                                    ...subBrand,
                                    categoryId: category?.categoryId,
                                    name: subBrand.subCategoryName
                                });
                            }

                        });
                    }
                }
            )
        }
    }

    getSubBrandsByBrandIds(data: any): Promise<any> {
        return this.httpService.getPartWarantiesSubBrandsList(data);
    }

    getData() {
        this.isLoading = true;
        Promise.allSettled([this.getPartType(), this.getBrands()]).then(
            (results: any[]) => {
                if (results?.length > 1) {
                    this.warrantySuggestions = results[0]?.value;
                    this.warrantySuggestionsList = results[0]?.value;
                    if (results[1]?.value?.categories?.length) {
                        this.warrantyBrandsSuggestion = results[1]?.value?.categories[0]?.records.map((brand: any) => {
                            return {
                                brandName: brand.categoryName,
                                brandID: brand.categoryId,
                                id: brand.categoryId,
                                _id: brand._id
                            }
                        }) || [];
                    }

                }
            },
            (err: any) => {
                this.helperService.showToaster('error', err);
            }
        ).finally(() => {
            //this.isLoading = false;
            if (this.isEditMode) {
                this.setData(this.dConfig.data);
            } else {
                this.isLoading = false;
                this.addAnotherCoverdProductLine();
            }
        })
    }

    getPartType(): Promise<any> {
        return this.httpService.getWarrantyPartsItems();
    }

    getBrands(
        offset = 0,
        limit = 27,
        searchQuery = this.searchBrandQuery,
        itemType = this.getItemType(),
        codeType = 'brand',
    ): Promise<any> {
        const conf = {
            offset,
            limit,
            searchQuery,
            itemType,
            codeType
        };
        return this.httpService.getPartWarrantiesBrands(conf);
    }

    getSubBrand(selectedBrandId: string, index: number) {
        const conf = {
            offset: 0,
            limit: 27,
            searchQuery: '',
            itemType: this.getItemType(),
            codeType: 'brand',
            categoryId: selectedBrandId
        };
        this.warranty.coveredProducts[index].isLoadingSubBrands = true;
        this.httpService.getPartWarantiesSubBrandsList(conf).then(
            (res: any) => {
                if (res?.subCategories?.length) {
                    const subBrandSuggestions = this.warranty.coveredProducts[index].productLineSuggestions;
                    const category = res?.category || {};
                    const subCategoriesList = res?.subCategories?.map((item: any) => {
                        return {
                            ...item,
                            categoryId: category?.categoryId,
                            name: item.subCategoryName
                        };
                    });
                    this.warranty.coveredProducts[index].productLineResults = this.helperService.deepCopy(subCategoriesList);

                    if (this.warranty.coveredProducts[index].selectedProductLines?.length) {
                        let subCatList: any[] = []
                        subCategoriesList?.forEach((subItem: any) => {
                            const selectedIdx = findIndex(this.warranty.coveredProducts[index].selectedProductLines, { subCategoryId: subItem?.subCategoryId });
                            if (selectedIdx < 0) {
                                subCatList.push(subItem);
                            }
                        });
                        this.warranty.coveredProducts[index].productLineSuggestions = [...subBrandSuggestions, ...subCatList];

                    } else {

                        this.warranty.coveredProducts[index].productLineSuggestions = [...subBrandSuggestions, ...subCategoriesList];
                    }

                }

            },
            (err: any) => {
                this.helperService.showToaster('error', err);
            }
        ).finally(() => {
            this.warranty.coveredProducts[index].isLoadingSubBrands = false;
        })
    }

    handleClose(isSuccess: boolean = true, data: any = {}) {
        this.dynamicDialogRef.close({ isSuccess, data });
    }


    handleChange(key: string, event: any) {
        this.warranty[key] = event;
    }

    onWarrantyTypeSelect(event: any) {
        this.warranty.type = event;
    }

    onClearWarrantyTypeSuggestion() {
        this.warranty.type = { name: '', partTerminologyID: '' };
        this.warrantySuggestions = this.helperService.deepCopy(this.warrantySuggestionsList);
    }

    onClearBrandSussgestion(index: number) {
        this.warranty.coveredProducts[index].brand.brandName = null;
        this.warranty.coveredProducts[index].brand.brandID = null;
        this.warranty.coveredProducts[index].selectedProductLines = []
        this.warranty.coveredProducts[index].brandWarrantySuggestion = this.helperService.deepCopy(this.warrantyBrandsSuggestion);
    }

    onWarrantyTypeSearch(query: string) {
        this.warrantySuggestions = this.warrantySuggestionsList?.filter((itemType: IItemType) => { return lowerCase(itemType.name).includes(lowerCase(query)) }) || [];
    }

    onCoveredBrandProductLineSelect(key: string, event: any, index: number) {
        if (key === 'brand') {
            this.warranty.coveredProducts[index][key] = event;
            this.warranty.coveredProducts[index].productLineSuggestions = [];
            this.getSubBrand(event?.brandID, index);
        } else if (key === 'productLine') {
            const pLineIndx = findIndex(this.warranty.coveredProducts[index].productLineSuggestions, { subCategoryId: event?.subCategoryId });
            if (pLineIndx > -1) {
                this.warranty.coveredProducts[index].productLineSuggestions.splice(pLineIndx, 1);
            }
            this.warranty.coveredProducts[index].selectedProductLines.push(event);

        }
    }

    onCoveredBrandSearch(event: any, index: number) {
        if (event) {
            this.warranty.coveredProducts[index].isLoadingBrands = true;
            const offset = 0,
                limit = 27,
                searchQuery = event,
                itemType = this.getItemType(),
                codeType = 'brand'
            this.getBrands(
                offset,
                limit,
                searchQuery,
                itemType,
                codeType
            ).then(
                (res: any) => {
                    if (res?.categories?.length) {
                        this.warranty.coveredProducts[index].brandWarrantySuggestion = res?.categories[0]?.records?.map((brand: any) => {
                            return {
                                brandName: brand.categoryName,
                                brandID: brand.categoryId,
                                id: brand.categoryId,
                                _id: brand._id
                            }
                        }) || [];
                    } else {
                        this.warranty.coveredProducts[index].brandWarrantySuggestion = [];
                    }

                },
                (err: any) => {
                    this.warranty.coveredProducts[index].brandWarrantySuggestion = [];
                    this.helperService.showToaster('error', err);
                }
            ).finally(() => {
                this.warranty.coveredProducts[index].isLoadingBrands = false;
            });
        }
    }

    onProductLineUpdate(item: IProductLine, index: number) {
        const updIndex = findIndex(this.warranty.coveredProducts[index].productLineSuggestions, { subCategoryId: item._id });

        if (updIndex > -1) {
            const data = {
                itemType: this.getItemType(),
                codeType: 'brand',
                categoryId: this.warranty.coveredProducts[index].productLineSuggestions[updIndex]?.categoryId,
                subCategoryName: item.name,
                subCategoryId: item._id
            };
            this.httpService.updateSubBrand(data).then(
                (res: any) => {
                    this.warranty.coveredProducts[index].productLineSuggestions[updIndex].subCategoryName = item.name;
                    this.helperService.showToaster('success', res);
                },
                (err: any) => {
                    this.helperService.showToaster('error', err);
                }
            );
        }

    }

    onSaveProductLine(item: IProductLine, index: number) {
        if (!trim(item?.name)) {
            return;
        }
        const data = {
            itemType: this.getItemType(),
            codeType: 'brand',
            categoryId: this.warranty.coveredProducts[index].brand.brandID,
            subCategoryName: item.name,
        };
        this.warranty.coveredProducts[index].isLoadingSubBrands = true;
        this.httpService.createSubBrand(data).then(
            (res: any) => {
                if (res.subCategory) {
                    const subBrand = { ...res.subCategory, categoryId: res?.category?.categoryId, name: res.subCategory.subCategoryName };
                    this.warranty.coveredProducts[index].selectedProductLines.push(subBrand);

                    // this.warranty.coveredProducts[index].productLineSuggestions = [...this.warranty.coveredProducts[index].productLineSuggestions, ...[subBrand]];
                }
            },
            (err: any) => {
                this.helperService.showToaster('error', err);
            }
        ).finally(() => {
            this.warranty.coveredProducts[index].isLoadingSubBrands = false;
        });
    }

    onDeleteProductLine(item: IProductLine, index: number) {
        this.httpService.deleteSubBrand(item.categoryId, item.subCategoryId,
            this.getItemType(),
        ).then(
            (res: any) => {
                this.warranty.coveredProducts[index].productLineSuggestions = [];
                this.getSubBrand(item.categoryId, index);
                this.helperService.showToaster('success', res);
            },
            (err: any) => {
                this.helperService.showToaster('error', err);
            }
        );
    }

    addAnotherCoverdProductLine() {
        const productLineObj = this.getCoverdProductLineObject();
        this.warranty.coveredProducts.push(productLineObj);
    }

    getCoverdProductLineObject(): ICoveredProduct {
        const productLineObj: ICoveredProduct = {
            brand: {
                brandName: '',
                brandID: '',
                id: null,
                _id: ''
            },
            productLine: {
                subCategoryId: '',
                subCategoryName: '',
                name: '',
                categoryId: '',
                _id: ''
            },
            productLineResults: this.helperService.deepCopy(this.warrantyProductLineSuggestions) || [],
            productLineSuggestions: this.helperService.deepCopy(this.warrantyProductLineSuggestions) || [],
            brandWarrantySuggestion: this.helperService.deepCopy(this.warrantyBrandsSuggestion) || [],
            selectedProductLines: [],
            isLoadingSubBrands: false,
            isLoadingBrands: false,
            brandError: false,
            subBrandError: false
        };

        return productLineObj;
        //this.warranty.coveredProducts.push(productLineObj);
    }

    removeCoveredBrandProductLine(index: number) {
        this.warranty.coveredProducts.splice(index, 1);
    }

    removeSelectedItem(productLineIndex: number, selectedItemIndex: number): void {
        const selectedSubBrand = this.warranty.coveredProducts[productLineIndex].selectedProductLines[selectedItemIndex];
        this.warranty.coveredProducts[productLineIndex].selectedProductLines.splice(selectedItemIndex, 1);
        const matchingProductLine = find(
            this.warranty.coveredProducts[productLineIndex].productLineResults,
            { subCategoryId: selectedSubBrand?.subCategoryId }
        );

        if (matchingProductLine) {
            this.warranty.coveredProducts[productLineIndex].productLineSuggestions.push(matchingProductLine);
        }

        //applied fix for the scenario only relevan t product item should be pushed  ALP-17920
        // else this.warranty.coveredProducts[productLineIndex].productLineSuggestions.push(selectedSubBrand);

        else {
            // ALP-17921 Fix: Add the removed sub-brand back to suggestions, ensuring it reappears in the dropdown.
            this.warranty.coveredProducts[productLineIndex].productLineSuggestions.push(selectedSubBrand);
        }
    }

    openConfirmationDialogOnEdit() {
        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
            styleClass: 'small-heading-dialog parts-warranty-confirmation',
            showHeader: false,
            data: {
                styleClassHeading: 'font-14',
                isCustomizedConfirmationBox: true,
                isCloseButtonHidden: true,
                isHTML: true,
                headerIcon: 'far fa-info-circle',
                headerIconType: 'none',
                title: `Are you sure you want to update this Warranty?`,
                message: `<div>
                            <p class="m-0 font-14 font-400 mb-2">
                              Changes made to this Warranty will have an affect on the following:
                            </p>
                            <ul class="flex-column gap-2">
                                <li>If you've updated the Warranty Name, this change will be reflected across the application.</li>
                                <li>If you've updated warranty configuration, items that do not match those classifications will no longer be associated with this Warranty.</li>
                                <li>These changes will not affect items that have already been sold under this Warranty.</li>
                            </ul>
                        </div>`,
                button: {
                    discard: {
                        border: 'none',
                    },
                    success: {
                        title: 'Confirm',
                    },
                    cancel: { title: 'Cancel' },
                },
            },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess }) => {
            if (isSuccess) {
                this.updateWarranty();
            }

            onClose.unsubscribe();
        });
    }

    isValidaData() {
        let isValid = true;
        if (!trim(this.warranty?.title)) {
            isValid = false;
            this.warranty.titleError = true;
        }

        if (this.isWarrantyPartType) {
            if (!this.warranty?.type?.partTerminologyID) {
                isValid = false;
                this.warranty.itemTypeError = true;
            }

            // ALP-17061: Removing Brand and Product Line requirement when creating warranties
            // if (this.warranty.coveredProducts.length) {
            //     this.warranty.coveredProducts.forEach((coveredItem: ICoveredProduct) => {
            //         if (!coveredItem.brand.brandID) {
            //             coveredItem.brandError = true;
            //             isValid = false;
            //         }

            //         if (!coveredItem.selectedProductLines?.length) {
            //             isValid = false;
            //             coveredItem.subBrandError = true;
            //         }
            //     });
            // }
        }

        return isValid;
    }

    handleSubmit() {
        if (this.isValidaData()) {
            if (this.isEditMode) {
                this.openConfirmationDialogOnEdit();
            } else {
                this.createWarranty();
            }
        }

    }

    createWarranty() {
        this.isSubmitting = true;
        const data = this.getformattedPayload();
        this.httpService.createWarranty(data).then(
            (res: any) => {
                this.helperService.showToaster('success', 'Warranty created successfully');
                this.isSubmitting = false;
                if (res && this.dataService.isGainSightPXEnabled) {
                    const itemtype: any = {
                        part: 'Part',
                        tire: 'Tire'
                    };
                    const dateTimeObj: any = this.helperService.getCurrentTimezoneDateTime();
                    const eventObj: any = {
                        tenantName: this.helperService.getCompany().companyName,
                        warrantySettingsName: data.title || '',
                        createdAt: this.dateService.formatDate(dateTimeObj, datetimeFormat.mmmdyyyy),
                        createdTime: this.dateService.getTime(dateTimeObj),
                        itemType: itemtype[data?.warrantyType] || ''
                    };
                    //console.log(eventObj);
                    (<any>window).aptrinsic('track', 'Warranty Settings added to Catalog', eventObj);
                }
                this.handleClose(true);
            },
            (err: any) => {
                this.isSubmitting = false;
                this.helperService.showToaster('error', err);
            }
        );

    }

    getformattedPayload(): any {
        const coveredBrands = this.warranty.coveredProducts.map((coveredPrd: ICoveredProduct) => {
            return {
                brand: {
                    id: coveredPrd?.brand?.brandID || null,
                    name: coveredPrd?.brand?.brandName || null,
                },
                productLines: coveredPrd?.selectedProductLines.map((productLine: IProductLine) => {
                    return {
                        id: productLine.subCategoryId,
                        name: productLine.subCategoryName
                    };
                })
            };
        })
        const data = {
            title: this.warranty.title,
            warrantyType: this.getItemType(),
            partType: {
                id: this.warranty.type ? this.warranty.type.partTerminologyID : null,
                name: this.warranty.type ? this.warranty.type.name : null
            },
            coveredBrands
        };

        return data;
    }

    updateWarranty() {
        this.isSubmitting = true;
        const data = this.getformattedPayload();
        this.httpService.updateWarranty(data, this.warrantyId).then(
            (res: any) => {
                this.helperService.showToaster('success', 'Warranty updated successfully');
                this.isSubmitting = false;
                this.handleClose(true);
            },
            (err: any) => {
                this.isSubmitting = false;
                this.helperService.showToaster('error', err);
            }
        );
    };

    getTireTypes() {
        // this.httpService.getTireTypes(null, 'tire').then((response: any) => {
        //     this.warrantySuggestions = response.categories.map((tire: any) => {
        //         return {
        //             name: tire.categoryName,
        //             partTerminologyID: tire.categoryId,
        //             _id: tire._id
        //         }
        //     }) || [];
        //     this.warrantySuggestionsList = this.helperService.deepCopy(this.warrantySuggestions);
        // },
        //     (err: any) => {
        //         this.helperService.showToaster('error', err);
        //     }
        // ).finally(() => {
        //     if (this.isEditMode) {
        //         this.setData(this.dConfig.data);
        //     }
        //     this.isLoading = false;
        // })
        this.warrantySuggestions = this.helperService.deepCopy(this.defaultTireTypeSuggestion.map((tireType: any) => {
            return {
                name: tireType.name,
                partTerminologyID: tireType.tireTypeId,
                _id: tireType.tireTypeId
            }
        })
        );
        this.warrantySuggestionsList = this.helperService.deepCopy(this.warrantySuggestions);
        if (this.isEditMode) {
            this.setData(this.dConfig.data);
        }
        this.isLoading = false;
    }

    getItemType() {
        return this.isWarrantyPartType ? 'part' : 'tire';
    }

}